import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { VoStandardVehicleInformationComponent } from 'src/app/components/features/vo-standard-vehicle-information/vo-standard-vehicle-information.component';

@Injectable({
  providedIn: 'root'
})
export class StandardVehicleInfoModalService {
  constructor(private readonly modalCtrl: ModalController) { }

  async open(event?: Event, capId?: number): Promise<void> {
    event?.preventDefault();
    event?.stopPropagation();

    const modal = await this.modalCtrl.create({
      component: VoStandardVehicleInformationComponent,
      componentProps: {
        capId
      }
    });

    await modal.present();
  }
}
